import { useEffect, useMemo, useState } from 'react';

import { UseTimerProps } from './Timer.types';

export const useTimer = ({ time, onTimeout }: UseTimerProps) => {
  const [second, setSecond] = useState(time);

  const locateWordSecond = useMemo(() => {
    if (second > 4) return 'секунд';
    if (second > 1) return 'секунды';
    return 'секунду';
  }, [second]);

  useEffect(() => {
    const _timer = setInterval(() => {
      setSecond((prevSecond) => {
        if (prevSecond > 0) {
          return prevSecond - 1;
        }
        clearInterval(_timer);
        onTimeout?.();
        return prevSecond;
      });
    }, 1000);

    return () => {
      clearInterval(_timer);
    };
  }, [second, onTimeout]);

  return { second, locateWordSecond };
};
